module.exports = __webpack_public_path__ + "img/logo.68d20a19.png";